import {ResourceRegistry} from '../registry/ResourceRegistry';
import {ExtendedResourceRegistryEntries, ResourceRegistryEntries} from '../registry/registry';

export abstract class AbstractResourceBuilder<OUTPUT, INPUT = any> {
    protected data!: INPUT;
    protected links!: ResourceRegistryEntries;

    build(data: INPUT, opts?: any): OUTPUT {
        this._buildResourceBase(data);

        return this._buildResource(data, opts);
    }

    protected abstract _buildResource(data: INPUT, opts?: any): OUTPUT;

    private _buildResourceBase(data: INPUT) {
        this.data = data;

        // TODO ts-ignore should be removed
        // @ts-ignore
        this.links = new ResourceRegistry(this.data._links).entries;
    }
}

export abstract class AbstractExtendedResourceBuilder<OUTPUT, INPUT = any> {
    protected data!: INPUT;
    protected links!: ExtendedResourceRegistryEntries;

    build(data: INPUT, opts?: any): OUTPUT {
        this._buildResourceBase(data);

        return this._buildResource(data, opts);
    }

    protected abstract _buildResource(data: INPUT, opts?: any): OUTPUT;

    private _buildResourceBase(data: INPUT) {
        this.data = data;

        // TODO ts-ignore should be removed
        // @ts-ignore
        this.links = new ResourceRegistry(this.data._links, true).extendedEntries;
    }
}
